import { render } from "./VisitMustKnow.vue?vue&type=template&id=5f323f80&scoped=true"
import script from "./VisitMustKnow.vue?vue&type=script&lang=js"
export * from "./VisitMustKnow.vue?vue&type=script&lang=js"

import "./VisitMustKnow.vue?vue&type=style&index=0&id=5f323f80&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f323f80"]])

export default __exports__